import { AVATAR_COLORS } from '../constants/misc.js';
export function avc(name) {
    const n = name || '';
    if (!n)
        return AVATAR_COLORS[0];
    const code = n.charCodeAt(0);
    return AVATAR_COLORS[code % AVATAR_COLORS.length];
}
export function ini(name) {
    const parts = (name || '').split(/\s+/).filter(Boolean);
    return parts
        .map((w) => w[0] ?? '')
        .join('')
        .slice(0, 2)
        .toUpperCase();
}
//# sourceMappingURL=avatar.js.map